// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';

const BadgeText = styled(BodyCopy)`
  color: ${(props) => props.theme.colorPalette.gray[800]};
  font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy1}px;
  font-weight: ${(props) => props.theme.fonts.fontWeight.normal};
  text-transform: capitalize;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: ${(props) => props.theme.spacing.ELEM_SPACING.REG};
  margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};

  @media ${(props) => props.theme.mediaQuery.large} {
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy2}px;
    height: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
`;

export default BadgeText;
